import React from 'react';

export const lazyImport = <T extends React.ComponentType<any>>(
  factory: () => Promise<{ [key: string]: T }>,
  name: string,
): React.LazyExoticComponent<T> =>
  React.lazy(() =>
    factory()
      .then(m => ({ default: m[name] }))
      .catch(e => {
        return { default: (() => null) as unknown as T };
      }),
  );
